import { Alert, Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./components/Header";

const FASES = [
  { value: 'GRUPOS',    label: 'Fase de Grupos' },
  { value: 'DEZESSEIS', label: '16-avos de Final' },
  { value: 'OITAVAS',   label: 'Oitavas de Final' },
  { value: 'QUARTAS',   label: 'Quartas de Final' },
  { value: 'SEMIFINAL', label: 'Semifinal' },
  { value: 'TERCEIRO',  label: 'Terceiro Lugar' },
  { value: 'FINAL',     label: 'Final' },
];

function formatDeadline(timestamp) {
  if (!timestamp) return '—';
  return new Date(timestamp * 1000).toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}

function AdmConfig() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(true);
  const [faseSelecionada, setFaseSelecionada] = useState('');
  const [deadlines, setDeadlines] = useState({});
  const [mensagem, setMensagem] = useState(null);
  const [pago, setPago] = useState({ grupos: 0, eliminatorias: 0 });
  const [dialogAcao, setDialogAcao] = useState(null);

  useEffect(() => {
    axios.get(process.env.REACT_APP_BACKEND + 'backend/adm/config.php', {
      headers: { 'Authorization': `Bearer ${localStorage.getItem("token_bolaodojuca")}` }
    })
    .then(res => {
      setFaseSelecionada(res.data.fase);
      setDeadlines(res.data.deadlines);
      setPago(res.data.pago ?? { grupos: 0, eliminatorias: 0 });
      setLoading(false);
      setOpen(false);
    })
    .catch(() => {
      localStorage.removeItem("token_bolaodojuca");
      navigate('/');
    });
  }, [navigate]);

  const handleAtualizar = () => {
    setLoading(true);
    setOpen(true);
    setMensagem(null);
    axios.post(
      process.env.REACT_APP_BACKEND + 'backend/adm/config.php',
      JSON.stringify({ fase: faseSelecionada }),
      { headers: { 'Authorization': `Bearer ${localStorage.getItem("token_bolaodojuca")}` } }
    )
    .then(() => {
      setLoading(false);
      setOpen(false);
      setMensagem({ tipo: 'success', texto: 'Fase atualizada com sucesso!' });
    })
    .catch(() => {
      setLoading(false);
      setOpen(false);
      setMensagem({ tipo: 'error', texto: 'Erro ao atualizar a fase.' });
    });
  };

  const carregaConfig = () => {
    axios.get(process.env.REACT_APP_BACKEND + 'backend/adm/config.php', {
      headers: { 'Authorization': `Bearer ${localStorage.getItem("token_bolaodojuca")}` }
    }).then(res => {
      setFaseSelecionada(res.data.fase);
      setDeadlines(res.data.deadlines);
      setPago(res.data.pago ?? { grupos: 0, eliminatorias: 0 });
    });
  };

  const handlePago = () => {
    setDialogAcao(null);
    setLoading(true);
    setOpen(true);
    axios.post(
      process.env.REACT_APP_BACKEND + 'backend/adm/pago.php',
      JSON.stringify({ acao: dialogAcao }),
      { headers: { 'Authorization': `Bearer ${localStorage.getItem("token_bolaodojuca")}` } }
    )
    .then(() => {
      carregaConfig();
      setLoading(false);
      setOpen(false);
      setMensagem({ tipo: 'success', texto: dialogAcao === 'habilitar_eli'
        ? 'Participantes habilitados para as eliminatórias!'
        : 'Participantes revertidos para a fase de grupos!' });
    })
    .catch(() => {
      setLoading(false);
      setOpen(false);
      setMensagem({ tipo: 'error', texto: 'Erro ao atualizar participantes.' });
    });
  };

  return (
    <div className='Main_Home'>
      <Header fase="FaseGrupos" />
      <div className="Body_Grupos">
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} />
        {loading
          ? <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress />
            </div>
          : <div style={{ padding: '24px', color: 'white' }}>
              <h2 style={{ marginBottom: '24px' }}>Configurar Fase Atual</h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                <FormControl sx={{ minWidth: 220 }}>
                  <InputLabel sx={{ color: 'white' }}>Fase</InputLabel>
                  <Select
                    value={faseSelecionada}
                    label="Fase"
                    onChange={e => { setFaseSelecionada(e.target.value); setMensagem(null); }}
                    sx={{
                      color: 'white',
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                      '& .MuiSvgIcon-root': { color: 'white' }
                    }}
                  >
                    {FASES.map(f => (
                      <MenuItem key={f.value} value={f.value}>{f.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <span style={{ fontSize: '0.95rem', color: '#ccc' }}>
                  Deadline: {formatDeadline(deadlines[faseSelecionada])}
                </span>
              </div>
              <div style={{ marginTop: '24px' }}>
                <Button variant="contained" onClick={handleAtualizar}>
                  Atualizar Fase
                </Button>
              </div>
              {mensagem && (
                <Alert severity={mensagem.tipo} sx={{ marginTop: '16px', maxWidth: 400 }}>
                  {mensagem.texto}
                </Alert>
              )}

              <hr style={{ borderColor: '#444', margin: '32px 0' }} />

              <h3 style={{ marginBottom: '16px' }}>Participantes nas Eliminatórias</h3>
              <p style={{ color: '#ccc', margin: '4px 0' }}>
                Na fase de grupos <span style={{ color: 'white' }}>(PAGO=1)</span>: <strong>{pago.grupos}</strong> participante(s)
              </p>
              <p style={{ color: '#ccc', margin: '4px 0 24px' }}>
                Nas eliminatórias <span style={{ color: 'white' }}>(PAGO=2)</span>: <strong>{pago.eliminatorias}</strong> participante(s)
              </p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <Button
                  variant="contained"
                  color="success"
                  disabled={pago.grupos === 0}
                  onClick={() => { setMensagem(null); setDialogAcao('habilitar_eli'); }}
                >
                  Habilitar Eliminatórias
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  disabled={pago.eliminatorias === 0}
                  onClick={() => { setMensagem(null); setDialogAcao('reverter_grupos'); }}
                >
                  Reverter para Grupos
                </Button>
              </div>
            </div>
        }
      </div>

      <Dialog open={!!dialogAcao} onClose={() => setDialogAcao(null)}>
        <DialogTitle>
          {dialogAcao === 'habilitar_eli' ? 'Confirmar Habilitação' : 'Confirmar Reversão'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {dialogAcao === 'habilitar_eli'
              ? `Isso vai habilitar ${pago.grupos} participante(s) para as eliminatórias (PAGO 1 → 2). Deseja continuar?`
              : `Isso vai reverter ${pago.eliminatorias} participante(s) para a fase de grupos (PAGO 2 → 1). Deseja continuar?`
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogAcao(null)}>Cancelar</Button>
          <Button onClick={handlePago} variant="contained" autoFocus>Confirmar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AdmConfig;
